<template>
  <div class="active-click" @click="turnOff">
    <div class="book-index effect8">
      <div class="book-index-text"><span class="">Spis treści</span></div>
      <div class="book-index-container">
        <div class="book-index-chapter" v-for="(chapter, index) in chapterData" :key="`chapter-key-${index}`">
          <tr-book-index-main-link>
            <div slot="chapterIndex">{{ chapter.chapterIndex }}</div>
            <div slot="text" v-html="chapter.text"></div>
          </tr-book-index-main-link>
          <tr-book-index-link
            :page-id="item.pageNumber"
            v-for="(item, index1) in chapter.items"
            :key="`chapter-item-key-${index1}`"
          >
            <div slot="chapterIndex">{{ item.chapterIndex }}</div>
            <div slot="text" v-html="item.text"></div>
            <div slot="pageIndex">{{ item.pageNumber }}</div>
          </tr-book-index-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrBookIndexMainLink from './TrBookIndexMainLink/TrBookIndexMainLink';
import TrBookIndexLink from './TrBookIndexLink/TrBookIndexLink';
import indexData from '__mainSrcDir/config/bookIndexData.js';
export default {
  name: 'tr-book-index',
  components: {
    TrBookIndexLink,
    TrBookIndexMainLink,
  },
  data: function () {
    return {
      data: indexData,
    };
  },
  methods: {
    turnOff() {
      this.$store.commit('SHOW_BOOK_INDEX', !this.showBookIndex);
      this.$store.commit('BOOK_INDEX_ACTIVE', !this.bookIndexActive);
    },
  },
  computed: {
    chapterData() {
      return this.data[`${this.$store.getters.multibookType}`]
        ? this.data[`${this.$store.getters.multibookType}`]
        : this.data;
    },
    showBookIndex() {
      return this.$store.getters.showBookIndex;
    },
    bookIndexActive() {
      return this.$store.getters.bookIndexActive;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/bookIndexVariable';
.active-click {
  position: absolute;
  z-index: 99999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .book-index {
    position: absolute;
    z-index: 100000;
    top: $bookIndexTop;
    left: $bookIndexLeft;
    width: $bookIndexWidth;
    height: $bookIndexHeight;
    background-color: $bookIndexBackgroundColor;
    // border: solid 1px black;
    border-radius: 10px 10px 0 0;
    // padding-bottom: 12px;
    font-size: $bookIndexFontSize;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    font-family: $bookIndexFontFamily;
    .book-index-text {
      display: flex;
      padding: $bookIndexTextPadding;
      span {
        font-size: $bookIndexTextFontSize;
        font-weight: bold;
      }
    }
    .book-index-container {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      overflow-y: scroll;
      margin-top: 28px;
      padding-bottom: 28px;
      .book-index-chapter {
        display: flex;
        width: 96%;
        flex-direction: column;
        padding: $bookIndexChapterPadding;
      }
    }
  }
  .effect8 {
    position: relative;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
  }
  .effect8:after,
  .effect8:before {
    content: '';
    position: absolute;
    z-index: -1; // box-shadow: 0 0 20px rgba(0,0,0,0.8);
    box-shadow: 3px 6px 20px rgba(0, 0, 0, 0.8);
    // top: 10px;
    // bottom: 10px;
    left: 0;
    right: 0;
    // border-radius: 100px / 10px;
  }
  .effect8:after {
    // right: 10px;
    left: auto;
    // transform: skew(8deg) rotate(3deg);
  }
}
</style>
